// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-ui----Footer-module---footer---18LyG","container":"src-ui----Footer-module---container---23Z0x"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/Footer.module.scss
// module id = 562
// module chunks = 35783957827783